import EstateCardList from "@/components/hlidaci-pes/EstateCardList";
import { useLanguage } from "@/context/LanguageContext";
import type { ChartDataItem, EstateCardProp } from "@/types";
import { Panel } from "@/components/ui/Panel";

type ChartSelectedOfferPanelProps = {
  selectedOffer: ChartDataItem | null;
  editSpecificResult: EstateCardProp["editSpecificResult"];
};

export function ChartSelectedOfferPanel({
  selectedOffer,
  editSpecificResult,
}: ChartSelectedOfferPanelProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      empty:
        "Najetím na bod v grafu nebo kliknutím na křivku zobrazíte odpovídající nabídku.",
    },
    en: {
      empty:
        "Hover a chart point or click the curve to show the matching offer.",
    },
  }[language];

  if (!selectedOffer) {
    return (
      <Panel className="flex min-h-[12rem] items-center justify-center">
        <p className="app-card-description">{copy.empty}</p>
      </Panel>
    );
  }

  return (
    <EstateCardList
      estateOffer={selectedOffer.offer}
      editSpecificResult={editSpecificResult}
      isMainPage={false}
      imageHeightClass="h-80 md:h-96"
    />
  );
}
